import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import { ManagePartisanChartState } from '../../hooks/use-manage-partisan-chart'
import ChartCreateDialog from '../../../../../components/dialogs/charts/chart-create-dialog'
import ChartSaveDialog from '../../../../../components/dialogs/charts/chart-save-dialog'

const ManagePartisanChartControlButton: React.FC<{
  state: ManagePartisanChartState
  errors: any
}> = ({
  state: {
    cancel,
    saveChart,
    finishAndInvoice,
    saveChartDialog,
    closeSaveChartDialog,
    chart,
    createAnotherChart,
    createChartDialog,
    closeCreateChartDialog,
    openCreateChartDialog,
  },
  errors,
}) => {
    const isErrors = Object.keys(errors).length > 0 ? true : false
    return (
      <>
        <div className="h-24 mb-8 bg-white">
          <div className="container flex items-center justify-end h-full gap-4 mx-auto">
            <button
              onClick={chart?.status === 'Completed' ? cancel : saveChart}
              className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              {`${chart?.status === 'Completed' ? 'Exit' : 'Save Chart'}`}
            </button>
          </div>
        </div>
        <ChartCreateDialog
          isOpen={createChartDialog}
          toggle={closeCreateChartDialog}
          createChart={createAnotherChart}
        />
        <ChartSaveDialog
          isOpen={saveChartDialog}
          toggle={closeSaveChartDialog}
          createChartDialogToggle={openCreateChartDialog}
          finishAndInvoice={finishAndInvoice}
          returnHome={cancel}
        />
      </>
    )
  }

export default ManagePartisanChartControlButton
